import React, { useCallback, useEffect, useState } from "react";
import { AdminHeader } from "@/components/admin/parts";
import { ImportJobCard } from "@/components/admin/wi/ImportJobCard";
import { ValidationReport } from "@/components/admin/wi/ValidationReport";
import { AuthorisePanel } from "@/components/admin/wi/AuthorisePanel";
import { BenchmarkSettings } from "@/components/admin/wi/BenchmarkSettings";
import { adminApi } from "@/lib/api";
import { usePolling } from "@/hooks/usePolling";

export default function WiImport() {
  const [rep, setRep] = useState(null);
  const load = useCallback(() => adminApi.get("/admin/wi/validation").then(({ data }) => setRep(data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  usePolling(load, 30000);
  return (
    <div data-testid="wi-import-page">
      <AdminHeader title="Import & Validation" subtitle="Historical warranty analysis — must be validated before any AI assessment of new claims" />
      <div className="p-8 grid xl:grid-cols-3 gap-6 items-start">
        <div className="xl:col-span-2 space-y-6">
          <ImportJobCard onChange={load} />
          <ValidationReport rep={rep} />
        </div>
        <div className="space-y-6">
          <AuthorisePanel rep={rep} onDone={setRep} />
          <BenchmarkSettings onSaved={load} />
        </div>
      </div>
    </div>
  );
}
